// @ts-ignore
import packageInfo from '../../package.json';
export const environment = {
  production: true,
  apiUrl: 'https://api-vendor.aclarian.com/api/',
  baseUrl: 'https://pittsburghstadiumauthority-vendor.aclarian.com',
  appName: 'The Stadium Authority | VendorV2',
  tokenizationKey: 'PaQmTu-VE6uUF-9V6acY-jecjXr',
  datadogClientToken: 'pub3dd385bb36b9c834a6a2d70955ebcb86',
  datadogApplicationId: 'b44a700d-7581-4c79-9ae4-cc39ff512045',
  datadogService: 'invoicing_pittsburgh_stadium_authority',
  ApiKey: 'Pd6@cRyV3#Gt8M%2',
  env: 'PROD',
  version: packageInfo.version,
};
